import { reducer as formReducer, formSelector } from '@xcritical/forms';

import { registryReducer } from '@crm-framework/registry';

import { dictionariesReducer } from '@crm-package/dictionaries';
import { ICoreState } from '@crm-package/app';

import { FORM_NAME } from './consts';
import { IWithdrawalFormState } from './models';

export const toolsReducers = {
  form: formReducer,
  registry: registryReducer,
  dictionaries: dictionariesReducer,
};

export const getWithdrawalFormData = (
  state: ICoreState
): IWithdrawalFormState => formSelector(state, FORM_NAME);
